import { HttpInterceptorFn } from "@angular/common/http";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userToken = getCookie("myCookie");
  // console.log("userToken", userToken);
  const modifiedReq = req.clone({
    setHeaders: {
      Authorization: `${userToken}`,
    },
  });
  return next(modifiedReq);
};

export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};
